import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FileText, Gavel, Handshake, MessageSquare, Search, User2, Users } from 'lucide-react';

export function HowItWorks() {
  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-violet-50/30 to-white dark:bg-neutral-900" id="how_works">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-6 md:mb-10">
          <span className="text-sm font-semibold tracking-widest text-violet-600 uppercase mb-3 block">
            Cómo funciona
          </span>
          <h2 className="text-3xl font-bold sm:text-4xl md:text-5xl leading-tight">
            ¿Cómo funciona{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-purple-600">
              Abogalia?
            </span>
          </h2>
        </div>
        
        <Tabs defaultValue="client" className="mx-auto">
          <TabsList className="bg-white border p-1 rounded-lg border-gray-400 px-4 mx-auto flex justify-center md:w-auto md:justify-start">
            <TabsTrigger value="client" className="data-[state=active]:bg-violet-600 data-[state=active]:text-white px-6 py-2 font-semibold">
              <User2 className="h-4 w-4" /> 
                <span className='hidden md:block'>Para clientes</span>
                <span className='block md:hidden'>Clientes</span>
            </TabsTrigger>
            <TabsTrigger value="lawyer" className="data-[state=active]:bg-violet-600 data-[state=active]:text-white px-6 py-2 font-semibold">
              <Gavel className="h-4 w-4" /> 
                <span className='hidden md:block'>Para abogados</span>
                <span className='block md:hidden'>Abogados</span>
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="client">
            <div className="flex flex-col items-center justify-center mt-6">
              <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
                <div className="text-center space-y-4">
                  <div className="w-16 h-16 bg-violet-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <FileText className="h-8 w-8 text-violet-600" />
                  </div>
                  <div className="bg-violet-600 text-white rounded-full w-8 h-8 flex items-center justify-center mx-auto text-sm font-bold">
                    1
                  </div>
                  <h3 className="text-xl font-semibold">Describí tu caso</h3>
                  <p className="text-gray-600">
                    Responde una serie de preguntas simples para entender tu situación
                  </p>
                </div>

                <div className="text-center space-y-4">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Search className="h-8 w-8 text-green-600" />
                  </div>
                  <div className="bg-green-600 text-white rounded-full w-8 h-8 flex items-center justify-center mx-auto text-sm font-bold">
                    2
                  </div>
                  <h3 className="text-xl font-semibold">IA genera un resumen</h3>
                  <p className="text-gray-600">
                    Nuestra inteligencia artificial analiza tu caso y lo categoriza automáticamente
                  </p>
                </div>

                <div className="text-center space-y-4">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Users className="h-8 w-8 text-purple-600" />
                  </div>
                  <div className="bg-purple-600 text-white rounded-full w-8 h-8 flex items-center justify-center mx-auto text-sm font-bold">
                    3
                  </div>
                  <h3 className="text-xl font-semibold">Recibí propuestas</h3>
                  <p className="text-gray-600">
                    Los abogados especializados en tu área reciben tu caso y te envían propuestas
                  </p>
                </div>

                <div className="text-center space-y-4">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <MessageSquare className="h-8 w-8 text-orange-600" />
                  </div>
                  <div className="bg-orange-600 text-white rounded-full w-8 h-8 flex items-center justify-center mx-auto text-sm font-bold">
                    4
                  </div>
                  <h3 className="text-xl font-semibold">Elegí tu Abogado</h3>
                  <p className="text-gray-600">
                    Revisá las propuestas y elegí la que mejor se adapte a vos
                  </p>
                </div>
              </div>
            </div>
          </TabsContent>
          
          <TabsContent value="lawyer">
            <div className="flex flex-col items-center justify-center mt-6">
              <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
                <div className="text-center space-y-4">
                  <div className="w-16 h-16 bg-violet-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Search className="h-8 w-8 text-violet-600" />
                  </div>
                  <div className="bg-violet-600 text-white rounded-full w-8 h-8 flex items-center justify-center mx-auto text-sm font-bold">
                    1
                  </div>
                  <h3 className="text-xl font-semibold">Explorá casos</h3>
                  <p className="text-gray-600">
                    Accedé a un marketplace de casos según tu especialidad o recibí alertas de oportunidades que te interesen.
                  </p>
                </div>

                <div className="text-center space-y-4">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <FileText className="h-8 w-8 text-green-600" />
                  </div>
                  <div className="bg-green-600 text-white rounded-full w-8 h-8 flex items-center justify-center mx-auto text-sm font-bold">
                    2
                  </div>
                  <h3 className="text-xl font-semibold">Enviá tu propuesta</h3>
                  <p className="text-gray-600">
                    Presentá tu enfoque legal con una propuesta clara y adaptada al cliente.
                  </p>
                </div>

                <div className="text-center space-y-4">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <MessageSquare className="h-8 w-8 text-purple-600" />
                  </div>
                  <div className="bg-purple-600 text-white rounded-full w-8 h-8 flex items-center justify-center mx-auto text-sm font-bold">
                    3
                  </div>
                  <h3 className="text-xl font-semibold">Contactos directos</h3>
                  <p className="text-gray-600">
                    Si aceptan tu propuesta, los clientes te escribirán directo por WhatsApp. Mantené tu perfil actualizado para destacar.
                  </p>
                </div>

                <div className="text-center space-y-4">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Handshake className="h-8 w-8 text-orange-600" />
                  </div>
                  <div className="bg-orange-600 text-white rounded-full w-8 h-8 flex items-center justify-center mx-auto text-sm font-bold">
                    4
                  </div>
                  <h3 className="text-xl font-semibold">Cerrá el acuerdo</h3>
                  <p className="text-gray-600">
                    Definí los términos con el cliente y comenzá a trabajar en su caso.
                  </p>
                </div>
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
}